
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/msg",
      function () {
        return require("private-next-pages/msg/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/msg"])
      });
    }
  